import { useQuery } from '@tanstack/react-query';
import { getSubdomain, isValidSubdomain } from '@zealy/utils';
import { tradingCompetitionKeys } from '../tradingCompetition.keys';
import { getTradingCompetitionLeaderboard } from '../tradingCompetition.service';
/**
 * Queries a trading competition leaderboard
 * @param options Configuration options for the query
 * @example const { data, isLoading } = useTradingCompetitionLeaderboard({ tradingCompetitionId: 'abc123', page: 1, pageSize: 20 });
 */
export const useTradingCompetitionLeaderboard = ({ subdomain, tradingCompetitionId, page = 1, pageSize = 20, enabled = true, }) => {
    const domain = subdomain || getSubdomain();
    return useQuery({
        queryKey: tradingCompetitionKeys.leaderboard(domain, tradingCompetitionId, page, pageSize),
        queryFn: async () => getTradingCompetitionLeaderboard(domain, tradingCompetitionId, page, pageSize),
        enabled: isValidSubdomain(domain) && !!tradingCompetitionId && enabled,
        retry: 1,
    });
};
